import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import BybitTrade from './BybitTrade';
import { Button, ButtonGroup, Typography } from '@mui/material';
import CoinChart from './CoinChart';
import TradeHistory from '../Trader/TradeHistory';
export default function TradeTab() {
  
  const [value, setValue] = React.useState('Trade');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', marginTop: '60px', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="Trade table" 
          variant="scrollable"
          gap={1}
          scrollButtons={true}
          >
                        <Tab sx={{paddingLeft: 0}} label={<Button size='small' sx={{width: '170px', marginLeft: '5px', bgcolor: '#383838', color: '#fff'}} variant="contained">Trade</Button>} value="Trade" />

            <Tab sx={{paddingRight: '1px'}} label={<Button size='small' sx={{width: '170px', marginRight: '5px', bgcolor: '#1c1c1b', color: '#fff'}} variant="contained">Charts</Button>} value="Charts" />            
            
          </TabList>
        </Box>
        <TabPanel sx={{width: '100%', marginX: 0, padding: '2px'}} value="Trade"><BybitTrade/></TabPanel>
        <TabPanel sx={{width: '100%', marginX: 0,  padding: '2px'}} value="Charts"><CoinChart/></TabPanel>

        
        
      </TabContext>
      <TradeHistory/>
    </Box>
  );
}
